import OptSend from "./OptSend";
import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import orderServices from "../../api-service/order-service";
import Visibility from "../utils/Visibility";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
export const BrowseProducts = ({ params, t }: any) => {
  return (
    <Link to={`/${params.domain}/${params.branch_id}`}>
      <button className=" bg-primary text-onPrimary px-4 py-2 rounded-lg hover:bg-primary-dark transition">
        {t("gloabl.browseProducts")}
      </button>
    </Link>
  );
};

export const CheckoutComponent = ({
  cartItems,
  total,
  t,
  params,
  loadCart,
}: any) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [note, setNote] = useState("");
  const [openOptSheet, setOpenOptSheet] = useState(false);
  const tokenOrder = localStorage.getItem("tokenOrder" + params.branch_id);
  const items = cartItems.map((item: any) => ({
    product_id: item.id,
    amount: item.amount,
    sub_option_id: item.option
      ? item.option.map((opt: any) => opt.subOption.id)
      : [],
    note: item.note || "",
  }));
  // const navigate = useNavigate();

  const isValidPhoneNumber = (phone: string) => {
    const phoneRegex = /^[0-9]{10,15}$/;
    return phoneRegex.test(phone);
  };
  const handleCheckout = async () => {
    if (!name || !phone) {
      if (!name || !phone) {
        toast.error(t("gloabl.phoneOrName"), {
          className: "bg-red-500 text-white rounded-lg shadow-lg",
          hideProgressBar: true,
        });
        return;
      }
      if (!isValidPhoneNumber(phone)) {
        toast.error(
          t("gloabl.phoneInvalid", {
            className: "bg-red-500 text-white rounded-lg shadow-lg",
            hideProgressBar: true,
          })
        );
        return;
      }
      // try {
      //   const otp = await orderServices
      //     .requestOtp({ phone: phone })
      //     .then((otp) => {
      //       setOpenOptSheet(true);
      //     });
      // } catch (error) {
      //   toast.error(t("gloabl.orderError"));
      // }
    } else {
      try {
        const table_id = sessionStorage.getItem("tableId");
        orderServices
          .storeOrder({
            domain: params.domain,
            // token: tokenOrder,
            items: items,
            note: note,
            table_id: table_id || 1,
            branch_id: params.branch_id,
            tenant_id: 1,
            customer_id: 1,
            nameCustomer: name,
            phoneCustomer: phone,
            // tenant_id: params.table_id ||1|| null,
            // customer_id: 1,
            success_url: `${origin}/${params.domain}/${params.branch_id}/orders?confirm_payment=true`,
            cancel_url: `${origin}/${params.domain}/${params.branch_id}/cart`,
          })
          .then((res) => {
            // toast.success(
            //   `${t("gloabl.orderSuccess")} # ${res.data.data.order_id}`,
            //   {
            //     onClick: () => {
            //       navigate(`/${params.domain}/${params.branch_id}/orders`);
            //     },
            //   }
            // );
            // if (!Cookies.get(`phone${params.branch_id}`)) {
            //   const towHourFromNow = new Date(
            //     new Date().getTime() + 2 * 60 * 60 * 1000
            //   );
            //   Cookies.set(`phone${params.branch_id}`, res.data.phone, {
            //     expires: towHourFromNow,
            //   });
            // }
            localStorage.setItem(
              "tokenOrder" + params.branch_id,
              res.data.phone
            );

            window.location.href = res.data.url;
            setName("");
            setPhone("");
            setNote("");
            // localStorage.removeItem(`cart${params.branch_id}`);
            // loadCart();
            // window.dispatchEvent(new Event("cart-updated"));
          })
          .catch((err) => toast.error(t("gloabl.orderError")));
      } catch (error) {
        toast.error(t("gloabl.orderError"), {
          className: "bg-red-500 text-white rounded-lg shadow-lg",
          hideProgressBar: true,
        });
      }
    }
  };
  return (
    <div className="flex flex-col gap-4 mt-4">
      {/* <Visibility visible={tokenOrder}> */}
      <input
        type="text"
        placeholder={t("contact.name")}
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <div dir={"ltr"}>
        <PhoneInput
          defaultCountry="AE" // الدولة الافتراضية
          value={phone}
          onChange={(value) => setPhone(value as string)}
          placeholder={t("contact.phone")}
          international
          countryCallingCodeEditable={true}
          displayInitialValueAsLocalNumber={true} // فواصل بين الأرقام تلقائية
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* </Visibility> */}

      <textarea
        placeholder={t("gloabl.addNote")}
        rows={3}
        value={note}
        onChange={(e) => setNote(e.target.value)}
        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary resize-none"
      ></textarea>
      <div className="flex items-center gap-2 ">
        <p className="text-onBackground font-semibold text-lg">
          {t("gloabl.totalPrice")}:
        </p>

        <p className="flex items-center gap-1 text-lg font-semibold">
          <UAEDirhamIcon className="w-4 h-4" /> {total}
        </p>
      </div>
      <button
        onClick={() => handleCheckout()}
        type="button"
        className="text-onPrimary bg-primary rounded-xl hover:bg-primary/90 focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium text-sm px-5 py-2.5 text-center"
      >
        {t("gloabl.checkout")}
      </button>
      <OptSend
        openOptSheet={openOptSheet}
        setOpenOptSheet={setOpenOptSheet}
        phone={phone}
        setPhone={setPhone}
        setName={setName}
        setNote={setNote}
        loadCart={loadCart}
        name={name}
        note={note}
        cartItems={items}
        branch_id={params.branch_id}
      />
    </div>
  );
};
